import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useUnreadTotal() {
  return useQuery({
    queryKey: ['unread-total'],
    refetchInterval: 8000,
    queryFn: async (): Promise<number> => {
      const {
        data: { user },
      } = await supabase.auth.getUser()
      if (!user) return 0

      const { data, error } = await supabase
        .from('conversations')
        .select('user_a, user_a_unread_count, user_b_unread_count')
        .or(`user_a.eq.${user.id},user_b.eq.${user.id}`)

      if (error) return 0

      return (data ?? []).reduce((sum, c) => {
        return (
          sum +
          (c.user_a === user.id
            ? c.user_a_unread_count
            : c.user_b_unread_count)
        )
      }, 0)
    },
  })
}
